export enum PaymentFrequency {
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
}
